import React from "react";
import { getClazz } from "../../../../graphql/queries";
import PropTypes from "prop-types";
import * as DataTypes from "../../../../constants/Data/DataTypes";
import GeneralInfo from "../../../Common/GeneralInfo";

const ClassGeneralInfo = (props) => {
  return (
    <GeneralInfo
      modelId={props.classId}
      modelName={"Class"}
      listOfProperties={[
        {
          key: 1,
          attributeName: "name",
          attributeTitle: "Name",
          description: "Class Name",
          dataType: DataTypes.String,
        },
        {
          key: 2,
          attributeName: "order",
          attributeTitle: "Order",
          description: "Class Appearance Order",
          dataType: DataTypes.String,
        },
        {
          key: 3,
          attributeName: "createdAt",
          attributeTitle: "Created At",
          description: "Class Created At",
          dataType: DataTypes.DateTime,
        },
        {
          key: 4,
          attributeName: "updatedAt",
          attributeTitle: "Updated At",
          description: "Class Updated At",
          dataType: DataTypes.DateTime,
        },
        {
          key: 5,
          attributeTitle: "School Name",
          description: "School which domain belongs to",
          dataType: DataTypes.String,
          attributeFetchFunction: (data) => {
            return data.school.name;
          },
        },
        {
          key: 5,
          attributeTitle: "College Name",
          description: "College which domain belongs to",
          dataType: DataTypes.String,
          attributeFetchFunction: (data) => {
            if (data.college) {
              return data.college.name;
            } else {
              return "---";
            }
          },
        },
      ]}
      queryFunction={getClazz}
      queryFunctionName={"getClazz"}
    />
  );
};

ClassGeneralInfo.propTypes = {
  classId: PropTypes.string.isRequired,
};

export default ClassGeneralInfo;
